module.exports = __webpack_public_path__ + "static/media/IMG_0755_Reduced.b9c47cfa.jpg";